import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Chart from './Charts';
import Deposits from './Deposits';
import Orders from './Orders';
import Navigation from './Navigation';
import { dashboardData } from '../data/dashboard';
import Button from '@mui/material/Button';
import { Edit } from '@mui/icons-material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { TextField } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import axios from '../services/axios';
import SimpleBackdrop from './SimpleBackdrop';

function SimpleDialog(props) {
  const { onClose, selectedValue, open } = props;
  const [loading, setLoading] = React.useState(false);
  const [input, setValue] = React.useState({
    name: '',
    amount: '',
    date: '',
    description: '',
    receipt: '',
  });

  const url = 'https://4ca8-103-177-203-246.in.ngrok.io/api/expenditure';

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleSave = async (event) => {
    event.preventDefault();
    try {
      
      const data = new FormData();
      data.append('name', input.name);
      data.append('amount', input.amount);
      data.append('date', input.date);
      data.append('description', input.description);
      data.append('invoiceNumber', input.invoiceNumber);
      data.append('vendorName', input.vendorName);
      data.append('photo', input.receipt);

      setLoading(true);
      const response = await axios.post('/expenditure', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },

      });

      setLoading(false);

      return alert('Expenditure added successfully');
    } catch (error) {
      console.log(error);
      setLoading(false);
      return alert('Something went wrong, please try again later');
      
    }
  };

  const handleChange = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    setValue({ ...input, [name]: value });

    if (name === 'receipt') {
      console.log(event.currentTarget.files[0]);
      console.log(event.currentTarget.files);
      setValue({ ...input, [name]: event.currentTarget.files[0] });
    }


  };

  if(loading) return <SimpleBackdrop/>

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Add Expenditure</DialogTitle>
      <DialogContent>
        <TextField
          id='date'
          label='Date'
          type='date'
          name='date'
          defaultValue='2017-05-24'
          sx={{ width: 220 }}
          onChange={handleChange}
          required={true}
          InputLabelProps={{
            shrink: true,
          }}
        />

        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Name of buyer'
          fullWidth
          required={true}
          name='name'
          onChange={handleChange}
        />
        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Item Description'
          fullWidth
          required={true}
          name='description'
          onChange={handleChange}
        />

        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Amount'
          fullWidth
          required={true}
          name='amount'
          onChange={handleChange}
        />
        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Invoice Number'
          fullWidth
          required={true}
          name='invoiceNumber'
          onChange={handleChange}
        />
        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Vendor Name'
          fullWidth
          required={true}
          name='vendorName'
          onChange={handleChange}
        />
        <Button variant='contained' component='label' color='secondary'>
          Upload Receipt
          <input
            type='file'
            name='receipt'
            required={true}
            onChange={handleChange}
          />
        </Button>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={handleClose}>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DashboardContent() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <Navigation heading='Expenditure Dashboard' data={dashboardData}>
      <Box
        component='main'
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Container sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={5}>
            {/* Chart */}
            <Grid item xs={12} md={8} lg={9}>
              <Paper
                sx={{
                  p: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 240,
                }}
              >
                <Chart />
              </Paper>
            </Grid>
            {/* Recent Deposits */}
            <Grid item xs={12} md={4} lg={3}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 240,
                }}
              >
                <Deposits />
              </Paper>
            </Grid>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Button
                variant='contained'
                endIcon={<Edit />}
                onClick={handleClickOpen}
              >
                Add an Expense
              </Button>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <Orders />
              </Paper>
            </Grid>
          </Grid>
          <SimpleDialog open={open} onClose={handleClose} />
        </Container>
      </Box>
    </Navigation>
  );
}

export default function InfrastructureDashboard() {
  return <DashboardContent />;
}
